import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tabsSectionFn = /* @__PURE__ */ createRecipe('tabs-section', {}, [])

const tabsSectionVariantMap = {}

const tabsSectionVariantKeys = Object.keys(tabsSectionVariantMap)

export const tabsSection = /* @__PURE__ */ Object.assign(memo(tabsSectionFn.recipeFn), {
  __recipe__: true,
  __name__: 'tabsSection',
  __getCompoundVariantCss__: tabsSectionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tabsSectionVariantKeys,
  variantMap: tabsSectionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tabsSectionVariantKeys)
  },
  getVariantProps: tabsSectionFn.getVariantProps,
})